import axios from "axios";
import {LOAD_USER} from '../types/users';

export const loadUser=(isAuthenticated)=>dispatch=>{
  axios.get("api/users/read/fetch-user").then(response => {
    dispatch(saveUser(response.data.user))
  })
}

export const saveUser=(data)=>{
  return{
    type: LOAD_USER,
    payload:data
  }
}
